<script>
  import options from './FilterComponentControls.options'
  export default options
</script>

<template>
  <section class="nlx-filter-component__controls">

      <template v-if="notInMobileDrawer">
        <SortingComponent class="nlx-sorting-component--desktop" />

          <ul class="nlx-filter-component__controls__selected-facets-list">
            <li v-if="searchString && searchString.length > 2">
              <button class="nlx-filter-component__controls__selected-facet" @click.prevent="selectSearch">{{searchString}}</button>
            </li>
            <template v-for="(facet,key) in selectedFacets" :key="key">
              <li>
                <button class="nlx-filter-component__controls__selected-facet" @click.prevent="selectFacet(facet.group,facet)">{{facet.group.displayName}}: {{ facet.displayName }}</button>
              </li>
            </template>
          </ul>
      </template>

      <SortingComponent v-if="inMobileDrawer" class="nlx-sorting-component--mobile" />

      <button class="nlx-filter-component__controls__filter-bar-toggle"
        id="filterbartoggle"
        @click="toggleFilterBar"
        aria-controls="filterbar"
        :aria-expanded="!!(filterBarExpanded)">
          {{getLabel('filter')}}
          <div class="nlx-filter-component__filter-chevron">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#000000" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg>
          </div>
      </button>
      <button class="nlx-filter-component__controls__filter-mobile-toggle"
        id="filterbartoggle"
        @click="toggleMobileFilter"
        aria-controls="filterbar"
        :aria-expanded="!!(filterBarExpanded)">
          {{getLabel('filter')}}
          <div class="nlx-filter-component__filter-chevron">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#000000" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg>
          </div>
      </button>

      <template v-if="notInMobileDrawer">
        <div class="nlx-filter-component__controls__facets" v-if="mainFilterFacets">
            <template v-for="(facet,facetKey) in mainFilterFacets.facets" :key="facetKey">
                  <input class="nlx-filter-component__filter-checkbox" 
                    :id="`filter${key}field${facetKey}`" 
                    :checked="facet.selected"
                    type="checkbox">
                  <label class="nlx-filter-component__filter-checkbox-label" 
                    :for="`filter${key}field${facetKey}`"
                    @click.prevent="selectFacet(mainFilterFacets,facet)">
                    {{facet.displayName}}
                  </label>
              </template>
              <p v-if="mainFilterFacets.emptyValueLabel" class="nlx-filter-component__empty-value-label">{{mainFilterFacets.emptyValueLabel}}</p>
        </div>
      </template>

      
  </section>
</template>
